import React from "react";
import {
  Typography,
  TextField,
  Box,
  Button,
  IconButton,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { AddBox } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoPopover from "../../../../utils/informationButton";

const PotentiometerResponseComponent = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <Typography variant="h6" className={props.classes.responseTitle}>
          {t("newEnigma.responses")}
        </Typography>
        <InfoPopover
          title={t("newEnigma.response_pot")}
          text={t("newEnigma.enter_label_pot")}
          src="/images/reponse-pot.webp"
        />
      </Box>

      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
          marginBottom: "16px",
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          className={props.classes.uploadFile}
          startIcon={<AddBox />}
          component="label"
          onClick={props.addPotentiometer}
        >
          {t("newEnigma.add_pot")}
        </Button>
      </Box>
      {props.state.formDatas?.potentiometerLabels?.map((label, index) => {
        let potentiometerId = `potentiometer-label-${index.toString()}`;
        let potentiometerLabel = `Label ${index} (${t("newEnigma.optionnel")})`;

        return (
          <div
            key={
              props.state.enigmaLoaded
                ? `${potentiometerId}potentiometerNotLoaded`
                : `${potentiometerId}potentiometerEnigmaLoaded`
            }
          >
            <Box
              direction="row"
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                flexDirection: "row",
              }}
            >
              <TextField
                id={potentiometerId}
                label={potentiometerLabel}
                variant="outlined"
                size="small"
                className={props.classes.textfieldPropositions}
                onChange={(event) =>
                  props.handlePotentiometerLabelChange(event, index)
                }
                type="text"
                value={label}
                key={
                  props.state.enigmaLoaded
                    ? `${potentiometerId}NotLoaded`
                    : `${potentiometerId}enigmaLoaded`
                }
              />
              <TextField
                id={`${potentiometerId}-value`}
                label={t("newEnigma.value")}
                type="number"
                inputProps={{ min: 0, max: 10 }}
                variant="outlined"
                size="small"
                className={props.classes.textfieldValue}
                onChange={(event) =>
                  props.handlePotentiometerValueChange(event, index)
                }
                value={
                  props.state.formDatas.potentiometerValues
                    ? props.state.formDatas.potentiometerValues.length > index
                      ? props.state.formDatas.potentiometerValues[index]
                      : ""
                    : ""
                }
                key={
                  props.state.enigmaLoaded
                    ? `${potentiometerId}ValueNotLoaded`
                    : `${potentiometerId}ValueenigmaLoaded`
                }
              />
              {index !== 0 ? (
                <IconButton
                  key={
                    props.state.enigmaLoaded
                      ? `${potentiometerId}RemoveBtnNotLoaded`
                      : `${potentiometerId}RemoveBtnControlenigmaLoaded`
                  }
                  edge="end"
                  aria-label="delete"
                  onClick={(e) => props.removePotentiometer(e, index)}
                >
                  <DeleteIcon style={{ color: "red" }} />
                </IconButton>
              ) : (
                <Box style={{ width: "35px" }} />
              )}
            </Box>
          </div>
        );
      })}
    </>
  );
};

export default PotentiometerResponseComponent;
